import {cookieStore} from 'libs/storage/storage';

const RETURNING_CUSTOMER_CL_COOKIE_NAME = 'returningCustomer';

/**
 * isUserHas10PercentCLDiscount function which returns is user has 10% discount on CL
 */
export const isUserHas10PercentCLDiscount = (cookies: {[key: string]: string} = {}) => {
    return Boolean(
        (__NODEJS__ && cookies[RETURNING_CUSTOMER_CL_COOKIE_NAME]) ||
            (!__NODEJS__ && cookieStore.get(RETURNING_CUSTOMER_CL_COOKIE_NAME)),
    );
};
